import type { ColorSchemePreference } from "@codeshare/theme";
import { useColorScheme } from "../hooks/use-color-scheme";
import { Icon, type IconName } from "./Icon";

const ICON: Record<ColorSchemePreference, IconName> = {
  system: "monitor",
  light: "sun",
  dark: "moon",
};

const NEXT: Record<ColorSchemePreference, ColorSchemePreference> = {
  system: "light",
  light: "dark",
  dark: "system",
};

const LABEL: Record<ColorSchemePreference, string> = {
  system: "System",
  light: "Light",
  dark: "Dark",
};

export function ThemeToggle() {
  const { preference, setPreference } = useColorScheme();
  return (
    <button
      type="button"
      className="activity-item"
      onClick={() => setPreference(NEXT[preference])}
      title={`Theme: ${LABEL[preference]} (click for ${LABEL[NEXT[preference]]})`}
    >
      <Icon name={ICON[preference]} size={20} />
      <span className="visually-hidden">Theme: {LABEL[preference]}</span>
    </button>
  );
}
